import {getRestApi} from './ApiAxios'

export const GenerarCertificadoCustodiaClinicaPorEmpresaId = async (
  empresaId
) => {
  const restApi = await getRestApi()
  return await restApi.get(
    'gato-api-function/GenerarCertificadoCustodiaClinicaPorEmpresaId',
    {
      params: {empresaId},
    }
  )
}

export const FachadaObtenerPagosOtrosServicios = async (empresaId) => {
  const restApi = await getRestApi()
  return await restApi.get(
    'gato-api-function/FachadaObtenerPagosOtrosServicios',
    {
      params: {empresaId},
    }
  )
}

export const CrearSolicitudReporte = async (payload) => {
  const apiReq = await getRestApi()
  return await apiReq.put('gato-api-function/CrearSolicitudReporte', payload)
}

export const GenerarDocumentoFactura = async (facturaId) => {
  const apiReq = await getRestApi()
  return await apiReq.post(
    'gato-api-function/GenerarDocumentoFactura',
    facturaId
  )
}
